import { InformationCircleIcon } from "@heroicons/react/24/outline";

export default EvalRunResultSelectedItemEmpty;

function EvalRunResultSelectedItemEmpty(props) {
  const { itemName } = props;

  return (
    <div className="flex h-full items-center justify-center text-gray-400 gap-x-2">
      <InformationCircleIcon className="size-4" /> <p>No {itemName}</p>
    </div>
  );
}
